class Native {
  testFunc(card) {
    document.body.append(card);
  }

  constructor() {
    window.$native = this;
  }
}

const native = new Native();

export default native;
